import { render, staticRenderFns } from "./PointSupplementTemplate.vue?vue&type=template&id=92e35d64&scoped=true"
import script from "./PointSupplementTemplate.vue?vue&type=script&lang=js"
export * from "./PointSupplementTemplate.vue?vue&type=script&lang=js"
import style0 from "./PointSupplementTemplate.vue?vue&type=style&index=0&id=92e35d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e35d64",
  null
  
)

export default component.exports